import { render, staticRenderFns } from "./Senders.vue?vue&type=template&id=14244ace&"
import script from "./Senders.vue?vue&type=script&lang=js&"
export * from "./Senders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports